import React, { useEffect, useRef, useState } from 'react';
import { SelectButton } from 'primereact/selectbutton';
import { isNullOrUndefined } from '@utils/utils';
import { useTranslation } from 'react-i18next';
import { setOrRemoveDataTestId, TestIdElement } from '@utils/testUtils';

interface ComponentProps {
  value: boolean;
  onChange: (stackable: boolean) => void;
  disabled?: boolean;
  dataTestId?: string;
}

export const Stackable: React.FC<ComponentProps> = ({ value, onChange, disabled = false, dataTestId }) => {
  const { t } = useTranslation('common');
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const values = [
    { name: t('Stackable.yes', 'Ano'), value: true },
    { name: t('Stackable.no', 'Ne'), value: false },
  ];

  useEffect(() => {
    if (isNullOrUndefined(value)) onChange(true);
  }, []);

  useEffect(() => {
    const buttons = Array.from(wrapperRef.current?.querySelectorAll?.('.p-selectbutton .p-button') ?? []) as TestIdElement[];

    buttons.forEach((button, index) => {
      setOrRemoveDataTestId(button, values[index]?.value === true ? dataTestId : undefined);
    });
  }, [dataTestId, values]);

  return (
    <div ref={wrapperRef}>
      <SelectButton
        value={value}
        options={values}
        optionLabel={'name'}
        optionValue={'value'}
        onChange={e => {
          onChange(e.value);
        }}
        disabled={disabled}
      />
    </div>
  );
};
